// get_product_tech_categories
export const GET_PRODUCT_SUBCATEGORIES = 'get_product_tech_categories';
export const GET_PRODUCT_SUBCATEGORIES_SUCCESSFUL =
  'get_product_tech_categories_successfull';
export const GET_PRODUCT_SUBCATEGORIES_FAILED =
  'get_product_tech_categories_failed';

// create_product_tech_category
export const CREATE_PRODUCT_TECH_CATEGORY = 'create_product_tech_category';
export const CREATE_PRODUCT_TECH_CATEGORY_SUCCESSFUL =
  'create_product_tech_category_successfull';
export const CREATE_PRODUCT_TECH_CATEGORY_FAILED =
  'create_product_tech_category_failed';

// update_product_tech_category
export const UPDATE_PRODUCT_TECH_CATEGORY = 'update_product_tech_category';
export const UPDATE_PRODUCT_TECH_CATEGORY_SUCCESSFUL =
  'update_product_tech_category_successfull';
export const UPDATE_PRODUCT_TECH_CATEGORY_FAILED =
  'update_product_tech_category_failed';

// delete_product_tech_category
export const DELETE_PRODUCT_TECH_CATEGORY = 'delete_product_tech_category';
export const DELETE_PRODUCT_TECH_CATEGORY_SUCCESSFUL =
  'delete_product_tech_category_successfull';
export const DELETE_PRODUCT_TECH_CATEGORY_FAILED =
  'delete_product_tech_category_failed';
